//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    color: var(--light-gray-5);
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
`;
export const PeriodDate = styled.ul`
    line-height: 22px;
    list-style: none;
    margin: 0;
    padding: 0;
`;